/**
 * A global namespace for aria-valuemin.
 */
const ariaValueMin = "aria-valuemin";
export default ariaValueMin;
